import React, { Component } from 'react'
import { Section } from '../../components'
import { LinkExpiredStyled } from './styled'

export class LinkTokenExpriedContainer extends Component {
  render() {
    return (
      <React.Fragment>
        <LinkExpiredStyled className="activate-page">
          <Section className="activate-wrapper">
            <Section className="notification">
              <p>Sorry,your invitation has expired</p>
            </Section>
          </Section>
        </LinkExpiredStyled>
      </React.Fragment>
    )
  }
}
